// Central aggregator — imports per-tool datasource maps and merges into a single DatasourceMap.
// To add a new tool: import its map and spread it into the export below.
import { logscaleMap } from './tool-datasource-mappings/crowdstrike-logscale.datasource'
import { defenderMap } from './tool-datasource-mappings/microsoft-defender.datasource'
import { sentinelMap } from './tool-datasource-mappings/microsoft-sentinel.datasource'
import { cortexXdrMap } from './tool-datasource-mappings/paloalto-cortex-xdr.datasource'
import { s1LegacyMap } from './tool-datasource-mappings/sentinelone.datasource'
import { s1PowerQueryMap } from './tool-datasource-mappings/sentinelone-powerquery.datasource'
import { googleSecOpsMap } from './tool-datasource-mappings/google-secops.datasource'
import { qradarMap } from './tool-datasource-mappings/qradar.datasource'
import { trendMicroMap } from './tool-datasource-mappings/trendmicro-visionone.datasource'
import { s1SingularityMap } from './tool-datasource-mappings/sentinelone-singularity.datasource'
import { splunkMap } from './tool-datasource-mappings/splunk.datasource'

import type { DatasourceMap } from './datasource.types'

export const datasourceMap: DatasourceMap = {
  ...logscaleMap,
  ...splunkMap,
  ...defenderMap,
  ...sentinelMap,
  ...cortexXdrMap,
  ...s1LegacyMap,
  ...s1SingularityMap,
  ...s1PowerQueryMap,
  ...trendMicroMap,
  ...googleSecOpsMap,
  ...qradarMap,
}
